module.exports = __webpack_public_path__ + "static/media/072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp.cda5fc71.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/072-ER18_1tDNnDXKzpSTxGYTrGwadq-4ReucYKMfp
// module id = 692
// module chunks = 0